// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"GlobalLoader_loaderWrapper__nO5oK","hide":"GlobalLoader_hide__HSAZv"};